import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
  providedIn: 'root'
})
export class TranslatorService {

  constructor(private translocoService: TranslocoService) { }

  public getTranslate(element: Array<any>): string {
    const lang = this.translocoService.getActiveLang();
    const browserLang = navigator.language?.split('-')?.[0];

    // Check if there is an element that matches the browser language
    for (let i = 0; i < element.length; i++)
      if (element[i].code === browserLang)
        return element[i].text;

    // Check if there is an element whose code matches the active language
    for (let i = 0; i < element.length; i++)
      if (element[i].code === lang)
        return element[i].text;

    // If no matches, return the first available element's text or an empty string if the array is empty
    return element.length > 0 ? element[0].text : "";
  }
}
